import {SelPanCollection} from 'module/selpan/SelPanCollection';
import JSON from 'json3';
import _ from 'lodash';
import {PersonModel} from 'module/selpan/impl/person/model/PersonModel';
import {PERSONS_PREFETCH_URL, PERSONS_URL} from 'module/Person/api/PersonAPI';

export const PersonCollection = SelPanCollection.extend({
	url: PERSONS_URL,
	preFetchUrl: PERSONS_PREFETCH_URL,
	favEntity: "pers",
	model: PersonModel,
	storageIdSuffix: "personVisibility",
	dict: {getSingularP: () => Promise.resolve("Person")},
	/**
	 * one time upgrade
	 */
	upgradeStorage: function () {
		var parsedStore = this.parseStorage();
		var v1 = this._upgradeStorageV1(parsedStore);
		var v2 = this._upgradeStorageV2(v1);
		localStorage.setItem(this.getStorageId(), JSON.stringify(v2));
	},
	_upgradeStorageV1: function (parsedStore) {
		if (_.isArray(parsedStore)) {
			//storage is in format [{persNr,visible,selected},...]
			//transforms to {scope: [{persNr,visible,selected},...]}
			var currentScope = _.result(this, 'storageScope');
			//scope should be "default" if not used
			var ret = {};
			ret[currentScope] = parsedStore;
			return ret;
		} else {
			return parsedStore;
		}
	},
	_upgradeStorageV2: function (parsedStore) {
		//storage is in format {scope: [{persNr,visible,selected}]}
		//transforms to {scope: [persNr,...]}
		var v2 = {};
		_.each(parsedStore, function (list, scope) {
			v2[scope] = _.map(list, function (object) {
				return object.persNr || object;
			});
		});
		return v2;
	},
});